import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioParametroSimensService {

  constructor( private requestUrl: ReportesRequestService) { }

  // Parametro Simens by Sede
  async getParametroSimensBySede(codigoBaseDatos: string, sede: number) {
    try {
      const response = await this.requestUrl.getRequest('parametro-simens/sede', [ codigoBaseDatos, { sde: sede } ]);
      return response;
    } catch (e) {
      console.log('ServicioParametroSimensService.');
    }
  }

}
